module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('bread-crumb', {
    attrs: {
      "routeName": 'About Us'
    }
  }), _vm._v(" "), _c('hero', {
    attrs: {
      "backgroundImage": _vm.slide_image + '',
      "content": _vm.slide_label
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "has-primary-background section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4",
    class: {
      'm-b-50': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)
    }
  }, [_c('h2', {
    staticClass: "title is-red is-3"
  }, [_vm._v("\n            " + _vm._s(_vm.mission_label) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "subtitle is-white is-5"
  }, [_vm._v("\n            " + _vm._s(_vm.mission) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-variable is-9"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "title is-red is-3"
  }, [_vm._v("\n            " + _vm._s(_vm.our_services_label) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('ul', _vm._l((_vm.our_services), function(service) {
    return _c('li', {
      staticClass: "subtitle is-white is-5 m-b-5 m-t-5"
    }, [_vm._v("\n              " + _vm._s(service.value) + "\n            ")])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-image",
    style: ({
      background: _vm.middle_image
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "has-white-background"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "has-white-background section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n              " + _vm._s(_vm.our_customers) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-paddingless is-marginless is-gapless is-mobile"
  }, [_c('div', {
    staticClass: "column flex is-vertically-centered"
  }, [_c('icon', {
    staticClass: "is-hoverable",
    class: {
      gray: false
    },
    attrs: {
      "scale": "2",
      "name": "chevron-left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prev($event)
      }
    }
  })], 1), _vm._v(" "), _c('carousel', {
    ref: "carousel",
    staticClass: "column is-10",
    attrs: {
      "navigationNextLabel": ">",
      "navigationPrevLabel": "<",
      "navigationEnabled": false,
      "paginationEnabled": false,
      "per-page": 2,
      "perPageCustom": [
        [770, 4]
      ],
      "navigateTo": 0,
      "paginationSize": 15,
      "paginationActiveColor": 'white',
      "paginationColor": 'gray'
    }
  }, _vm._l((_vm.customers), function(customer) {
    return _c('slide', [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "customer-image",
      attrs: {
        "src": ("https://" + (_vm.baseURL()) + (customer.value.path)),
        "alt": customer.value.title,
        "title": customer.value.title
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "column flex is-vertically-centered"
  }, [_c('icon', {
    staticClass: "is-hoverable",
    class: {
      gray: false
    },
    attrs: {
      "scale": "2",
      "name": "chevron-right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.next($event)
      }
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "has-primary-background section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "title is-red is-3"
  }, [_vm._v("\n            " + _vm._s(_vm.letter_label) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "subtitle is-white is-5 m-b-15",
    domProps: {
      "innerHTML": _vm._s(_vm.letter)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title m-b-5 m-t-15 is-white is-4"
  }, [_vm._v("\n            " + _vm._s(_vm.letter_signature) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "title m-t-5 is-red is-5"
  }, [_vm._v("Chief Excutive Officer")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "title is-red is-3"
  }, [_vm._v("Our Customers")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43f37a2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/pages/about.vue
// module id = 1139
// module chunks = 1